import { IntegrationFunctions } from "./IntegrationFunctions";
import { AgentSDK } from "./js/AgentSDK";

export class IntegrationAgentSDK {
    buildClient() {
        const params = {
            "sdkService" : new AgentSDK,
        };
        return new IntegrationFunctions(params);
    };
};